import gql from "graphql-tag";

export const GET_VERSIONES_OPCIONES = gql`
query GetVersionesOpciones {
  GetVersionesOpciones {
    so
    nombre
    opciones {
      version
      mensaje
      multicanal
    }
  }
}
`